import React from "react";

import { isNil } from "lodash";

import { Box, Stack, Text, Wrap, WrapItem } from "@chakra-ui/react";

import { Option } from "../../../../types";

import AnswerFrom from "./AnswerForm";
import AnswerCommentReview from "./AnswerCommentReview";
import AnswerTimeSpentReview from "./AnswerTimeSpentReview";

import { AnswerReviewProps } from "./types/AnswerReviewProps";

const AnswerSelectorMultipleReview: React.FC<AnswerReviewProps> = React.memo(
  ({ answer, question, path }) => {
    const selectedOptions = (question.options as Option[])?.filter(
      ({ value }) => answer.value?.selector?.includes(value)
    );

    return (
      <Stack spacing="4">
        <AnswerFrom {...{ answer, path, omit: answer.isEmpty }} />
        {selectedOptions.length > 0 && (
          <Wrap
            spacing="3"
            maxWidth="2xl"
            w="full"
            id={`${path}.answer.${answer.id}.value`}
          >
            {selectedOptions.map((selectedOption) => (
              <WrapItem key={selectedOption.value}>
                <Box px="5" py="2" rounded="xl" bgColor="brand">
                  <Text
                    color="white"
                    fontWeight="bold"
                    fontSize="md"
                    id={`${path}.answer.${answer.id}.value.${selectedOption?.value}`}
                  >
                    {selectedOption.label}
                  </Text>
                </Box>
              </WrapItem>
            ))}
          </Wrap>
        )}
        {answer.value?.comment && (
          <AnswerCommentReview {...{ answer, question, path }} />
        )}
        {!isNil(answer.timeSpent) && (
          <AnswerTimeSpentReview {...{ answer, question, path }} />
        )}
      </Stack>
    );
  }
);

export default AnswerSelectorMultipleReview;
